// @flow

import * as React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import type { Reducers } from '../reducers';
import type { Project } from '../auth/with-project-context';
import type { TaskDetailState } from './reducer';

import ActionTypes from './action-types';
import TaskDetail from './task-detail';
import CustomModal from '../components/custom-modal';

import withProjectContext from '../auth/with-project-context';

type Props = {
  activityId: number,
  taskName: string,
  taskId: number,
  project: Project,
  dispatch: Object => mixed,
  data: TaskDetailState,
};

class TaskDetailContainer extends React.Component<Props> {
  componentDidMount() {
    this.props.dispatch({
      type: ActionTypes.GET_TASK_DETAIL,
      data: {
        activityId: this.props.activityId,
        taskId: this.props.taskId,
        projectId: this.props.project.id,
      },
    });
  }

  componentWillUnmount() {
    this.props.dispatch({ type: ActionTypes.CLEAR_TASK_DETAIL });
  }

  closeModal = () => {
    this.props.dispatch({
      type: 'hideModal',
    });
  }

  render(): React.Node {
    return (
      <CustomModal onClose={this.closeModal}>
        <TaskDetail task={this.props.data.task} taskName={this.props.taskName} />
      </CustomModal>
    );
  }
}

const Component: any = compose(
  connect((state: Reducers): { data: Object } => ({ data: state.taskDetail })),
  withProjectContext,
)(TaskDetailContainer);

export default Component;
